module.exports = __webpack_public_path__ + "9f8fb2a7bde98980d8b1f32a19d46296.jpg";